import { Injectable, Injector } from '@angular/core';
import { ChecklistListDataModel } from './checklist-list-data.model';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { ChecklistService } from '../checklist.service';
import { IGetInstanceService } from '@fi-app/utilities/fi-model/get-instance-service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Injectable()
export class ChecklistListDataService implements IGetInstanceService {
    constructor(
        private injector: Injector,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private loadingService: LoadingService,
        private checklistService: ChecklistService,
        private detectDevices: DetectDevicesService,
    ) {}

    getInstance(isLocalSort?: boolean, defaultColumn?: string, defaultReverse?: boolean) {
        return new ChecklistListDataModel(
            this.injector,
            this.accessToApplicationTypeService,
            this.loadingService,
            this.checklistService,
            this.detectDevices,
            isLocalSort,
            defaultColumn,
            defaultReverse,
        );
    }

    getExtendedSearchInstance() {
        return new ChecklistListDataModel(
            this.injector,
            this.accessToApplicationTypeService,
            this.loadingService,
            this.checklistService,
            this.detectDevices,
            undefined,
            undefined,
            undefined,
            true,
        );
    }
}
